import enFile from '../lang/en';
import jaFile from '../lang/ja';
import frFile from '../lang/fr';
import itFile from '../lang/it';
import deFile from '../lang/de';
import esFile from '../lang/es';

function updateLanguage (that,lang){
    localStorage.setItem('lang', lang);
    that.setState({
        lang: lang,
        message: getMessage(lang),
    });
};

function getMessage(lang) {
    switch (lang) {
        case 'en':
            return enFile
        case 'ja':
            return jaFile
        case 'fr':
            return frFile
        case 'it':
            return itFile
        case 'de':
            return deFile
        case 'es':
            return esFile
        default:
            return enFile
    }
}

export { updateLanguage ,getMessage }